import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import cn from 'classnames';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import styles from './DatePicker.module.scss';
const DatePicker = ({ className, onChange, placeholder }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const handleChange = (date) => {
        setSelectedDate(date);
        onChange(date);
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsx(ReactDatePicker, { placeholderText: placeholder, className: styles.date, selected: selectedDate, onChange: handleChange }), _jsx(Calendar, { className: styles.calendar })] })));
};
export default DatePicker;
